import React from "react";
import SkillsSection from "../components/MainSection/SkillsSection";

const Skills = () => {
  return (
    <div>
      <SkillsSection />
    </div>
  );
};

export default Skills;
